import { Directive, DoCheck, ElementRef, Renderer2 } from '@angular/core';
import { Subject, take } from 'rxjs';
import { MedicalHistoryHelper } from '../helpers/medical-history.helper';

@Directive({
    selector: '[dianaInitialInputRoundNumberMask]',
    standalone: false
})
export class InitialInputRoundNumberMaskDirective implements DoCheck {

  private valueChanges: Subject<number> = new Subject<number>();
  private isUpdated = false;

  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) {
    this.valueChanges.pipe(take(1)).subscribe((value) => {
      const roundedValue =  MedicalHistoryHelper.roundToTwoDecimals(value);
      this.updateInputValue(roundedValue);
      this.isUpdated = true;
      this.valueChanges.complete();
    });
  }
  /**
   * Used this lifecyle event because only on the second tick is went the input is updated with the initial value
   */
  ngDoCheck() {
    const input: HTMLInputElement = this.elementRef.nativeElement;
    const initialValue = input.value;
    if (input.value && !this.isUpdated) {
      this.valueChanges.next(Number(initialValue))
    }
  }

  private updateInputValue(value: number): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
  }
}
